<template>
  <div
    :id="'screen'"
    :style="{opacity: opacity}"
  >
    <main class="scrollable container">
      <h2 :style="{marginBottom: '20px'}">More</h2>
      <ul
        :style="{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '11px',
        }"
      >
        <li
          :key="item.id"
          class="clickable row-center"
          v-for="item in moreItems"
          :style="{
            gap: '10px',
            backgroundColor: '#FFF6F2',
            padding: '14px',
            borderRadius: '14px',
          }"
          @click="$router.push(item.route)"
        >
          <component :is="item.icon" />
          <h5 class="number-of-lines-1">{{ item.title }}</h5>
        </li>
      </ul>
    </main>
  </div>
</template>

<script setup>
// svg
import {EditSvg} from '@/assets/svg';
import {HeartSvg} from '@/assets/svg';
import {MessageSvg} from '@/assets/svg';
import {MaximizeSvg} from '@/assets/svg';
import {BarChartSvg} from '@/assets/svg';
import {FileTextSvg} from '@/assets/svg';
import {CreditCardSvg} from '@/assets/svg';
import {HelpCircleSvg} from '@/assets/svg';

// other
import {routes} from '@/routes';
import {useOpacity} from '@/hooks';

const opacity = useOpacity();

const moreItems = [
  {
    id: 1,
    title: 'Add new card',
    icon: CreditCardSvg,
    route: routes.OPEN_NEW_CARD,
  },
  {
    id: 2,
    title: 'Create invoice',
    icon: EditSvg,
    route: routes.CREATE_INVOICE,
  },
  {
    id: 3,
    title: 'Statistics',
    icon: BarChartSvg,
    route: routes.STATISTICS,
  },
  {
    id: 4,
    title: 'Scanner QR',
    icon: MaximizeSvg,
    route: '',
  },
  {
    id: 5,
    title: 'FAQ',
    icon: HelpCircleSvg,
    route: routes.FAQ,
  },
  {
    id: 6,
    title: 'Support',
    icon: MessageSvg,
    route: '',
  },
  {
    id: 7,
    title: 'Charity',
    icon: HeartSvg,
    route: '',
  },
  {
    id: 8,
    title: 'Privacy policy',
    icon: FileTextSvg,
    route: routes.PRIVACY_POLICY,
  },
];
</script>
